module.exports = __webpack_public_path__ + "img/pay-apple.1e16b36.png";